import createReducer from 'utils/redux/createReducer'

const initialState = {
  status: 'Open',
  owner: 'All',
  landlord: 'All',
  property: 'All',
  tenant: 'All'
}

export default createReducer(initialState, {
	PROJECT_FILTER_UPDATED: (currentState, action) => (
		{
			status: (action.data.status)? action.data.status : currentState.status
		  , owner: (action.data.owner)? action.data.owner : currentState.owner
		  , landlord: (action.data.landlord)? action.data.landlord : currentState.landlord
		  , property: (action.data.property)? action.data.property : currentState.property
		  , tenant: (action.data.tenant)? action.data.tenant : currentState.tenant
		}
	),
	CLEAR_PROJECT_FILTERS: () => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/projectFiltersReducers.js